import { OrderStatusGroup, ShippingPartnerName } from '@tcr-erp/shared';
import type { TenantOrder } from '@/mocks/orders';
import { FULFILLMENT_ACTION_ROLES } from './orderActionRoles';
import {
  isTerminalOrder,
  planForStatusGroup,
  split,
  TERMINAL,
  type BatchActionPlan,
} from './batchOrderActions';

/**
 * TCR-2264 — kế hoạch hàng loạt cho các mục mà `planBatchOrderActions` chưa có (Đã gửi hàng, Xoá
 * hẳn nháp, Bỏ đánh dấu bỏ qua, In hoá đơn). Trước dùng cho menu ⋮ khi chọn nhiều đơn; từ TCR-2504
 * dùng cho panel "Hành động cho N đơn hàng" (`buildMultiOrderSections`).
 */
export interface RowMenuExtraPlans {
  markPickedUp: BatchActionPlan | null;
  draft: BatchActionPlan | null;
  unskip: BatchActionPlan;
  print: BatchActionPlan;
}

const NO_PICKED_UP_ROLE = 'Bạn không có quyền đánh dấu đơn đã gửi hàng';
const NOT_MANUAL_SHIPPING = 'Đơn giao qua hãng vận chuyển, trạng thái tự cập nhật';
const NOT_SKIPPED = 'Đơn chưa được đánh dấu bỏ qua';
const NOT_AWAITING_HANDOVER = 'Không ở trạng thái Chờ gửi hàng';
const NOT_DRAFT = 'Không phải đơn Nháp';

export function planRowMenuExtras(rows: TenantOrder[], roles: readonly string[]): RowMenuExtraPlans {
  const canFulfill = FULFILLMENT_ACTION_ROLES.some((role) => roles.includes(role));
  // TCR-2504 — có ≥1 đơn đúng trạng thái là có nút, đếm số đơn đủ điều kiện (xem `BatchOrderPlans`).
  return {
    markPickedUp: planForStatusGroup(rows, OrderStatusGroup.AWAITING_HANDOVER, NOT_AWAITING_HANDOVER, (order) => {
      if (!canFulfill) return NO_PICKED_UP_ROLE;
      return order.shipping?.shipping_partner?.name === ShippingPartnerName.MANUAL ? null : NOT_MANUAL_SHIPPING;
    }),
    draft: planForStatusGroup(rows, OrderStatusGroup.DRAFT, NOT_DRAFT),
    unskip: split(rows, (order) => {
      if (isTerminalOrder(order)) return TERMINAL;
      return order.skipped ? null : NOT_SKIPPED;
    }),
    print: split(rows, (order) => (isTerminalOrder(order) ? TERMINAL : null)),
  };
}
